var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartcube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.22545L20.8569 19.8567L39.9339 5.22545L24.9188 0L0 5.22545Z",
    fill: "url(#paint0_linear_15395_281442)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.21875L6.20687 26.1206L17.8447 34.4813L20.8569 19.85L0 5.21875Z",
    fill: "url(#paint1_linear_15395_281442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9092 16.7215L24.9062 0L39.9214 5.22545V16.7215H36.9092Z",
    fill: "#3BCD3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20312 26.1402L36.918 16.7344H39.9302L17.841 34.5009L6.20312 26.1402Z",
    fill: "#02104F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15395_281442",
    x1: 33.862,
    y1: 10.3814,
    x2: 2.20933,
    y2: 9.09258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1EBB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    stopColor: "#99E3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#5ECFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#00B09B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15395_281442",
    x1: 5.20551,
    y1: 6.22022,
    x2: 16.4431,
    y2: 29.1264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3024,
    stopColor: "#007465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#349E79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartcube);
export default __webpack_public_path__ + "static/media/Smartcube.078ed02fa7861eeb7dc3d77c771aef82.svg";
export { ForwardRef as ReactComponent };